export interface SharepointItem {
    id: string;
    name: string;
    folder?: object;
    file?: object;
    isSite?: boolean;
    isDrive?: boolean;
    isMyDrive?: boolean;
    siteId?: string;
    driveId?: string;
    parentReference?: { driveId: string };
}

export interface NavEntry {
    id?: string;
    name: string;
    type: (typeof NAV_TYPES)[keyof typeof NAV_TYPES];
    siteId?: string;
    driveId?: string;
}

export const NAV_TYPES = {
    ROOT: 'root',
    MY_DRIVE: 'myDrive',
    SITE: 'site',
    DRIVE: 'drive',
    FOLDER: 'folder',
} as const;
